import React from "react";
import "./ConfirmationPage.css";
import { FaCheckCircle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import ModerationVisitHeader from "../../components/ModerationVisitHeader";

const ConfirmationPage = () => {
  const navigate = useNavigate();

  const onClickBackToDashboard = () => {
    navigate("/dashboard");
  };
  return (
    <div className="page-layout">
      <ModerationVisitHeader showActions={false} />
      <div className="request-submitted-container">
        <div className="request-header">
          <div className="request-icon">
            <FaCheckCircle size={48} color="#2B8000" />
          </div>
          <div className="request-title-message">
            <h2>Your request has been submitted</h2>
          </div>
        </div>

        <div className="request-section">
          <div className="section-body">
            Your moderator will get in touch to arrange the visit date using the
            contact details you have provided.
          </div>
        </div>

        <div className="dashboard-btn-container">
          <button className="dashboard-btn" onClick={onClickBackToDashboard}>
            Back to dashboard
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationPage;
